import { Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './components/Button';
import { Heading } from './components/Heading';
import { Route } from './constants';

export const NotFound = () => {
  const navigate = useNavigate();

  const heading = 'Page Not Found';
  const message = `We're sorry, but the page you're looking for isn't available. It may have been moved, deleted, or the link might be incorrect.`;

  return (
    <div className="flex flex-col items-center justify-center pt-4">
      <Heading size="l">{heading}</Heading>
      <p className="my-4">{message}</p>
      <Button icon={Home} onClick={() => navigate(Route.Home)}>
        Return Home
      </Button>
    </div>
  );
};
